(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ah-footer"]) return;
  try {
    
  document.querySelectorAll('.ah-footer__contact').forEach((panel) => {
    if (panel.querySelector('[role="status"], .form__message, .errors')) panel.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
